export const FETCH_FEATURES_PENDING   = 'FETCH_FEATURES_PENDING'
export const FETCH_FEATURES_FULFILLED = 'FETCH_FEATURES_FULFILLED'
export const FETCH_FEATURES_REJECTED  = 'FETCH_FEATURES_REJECTED'

export const SET_DISABLE_FEATURE   = 'SET_DISABLE_FEATURE'
export const SET_ENABLE_FEATURE    = 'SET_ENABLE_FEATURE'
